import { render, staticRenderFns } from "./EditWallet.vue?vue&type=template&id=5910bfb8&scoped=true&"
import script from "./EditWallet.vue?vue&type=script&lang=js&"
export * from "./EditWallet.vue?vue&type=script&lang=js&"
import style0 from "./EditWallet.vue?vue&type=style&index=0&id=5910bfb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5910bfb8",
  null
  
)

export default component.exports